export const GOOGLE_CLIEN_ID = '67175754469-586cbdffssnibggkvfs9uvn26hhj5eum.apps.googleusercontent.com';
